// extracted by mini-css-extract-plugin
module.exports = {"root":"MatchTimer_root__Bj0Mo","matchStatus":"MatchTimer_matchStatus__ib41f"};